// extracted by mini-css-extract-plugin
export default {"contentWrapperBottom":"PaymentContainer_contentWrapperBottom__JTG2X"};